import slugify from "./component-library82.mjs";
import LinkButton from "./component-library3.mjs";
import BrodosLogo from "./component-library137.mjs";
import "./component-library138.mjs";
import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {
  name: "Breadcrumb",
  components: { BrodosLogo, LinkButton },
  props: {
    homeName: { type: String, default: "" },
    items: {
      type: Array,
      default: () => []
    },
    fullBackground: { type: Boolean },
    fullWidth: { type: Boolean },
    allWhite: { type: Boolean },
    withBrodos: { type: Boolean }
  },
  computed: {
    containerClass() {
      return {
        "breadcrumb--full-background": this.fullBackground,
        "breadcrumb--all-white": this.allWhite,
        "breadcrumb--full-width": this.fullWidth
      };
    }
  },
  methods: {
    isActive(index) {
      const lastIndex = this.items.length - 1;
      return index === lastIndex;
    },
    trackingKey(label) {
      return slugify(`context.text.breadcrumb.${label}`, true);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("nav", { staticClass: "breadcrumb", class: _vm.containerClass, attrs: { "aria-label": "Du bist hier:" } }, [_c("ul", { staticClass: "breadcrumb__list", attrs: { "itemscope": "", "itemtype": "http://schema.org/BreadcrumbList" } }, [_vm.homeName ? _c("li", { staticClass: "breadcrumb__element", attrs: { "itemprop": "itemListElement", "itemscope": "", "itemtype": "http://schema.org/ListItem" } }, [_c("LinkButton", { staticClass: "breadcrumb__link", attrs: { "data-tealium-rel": _vm.trackingKey(_vm.homeName), "exact": "", "itemprop": "item", "no-styling": "", "tag": "nuxt-link", "to": "/" } }, [_c("span", { attrs: { "itemprop": "name" } }, [_vm._v(_vm._s(_vm.homeName))])]), _c("span", { attrs: { "content": "1", "itemprop": "position" } })], 1) : _vm._e(), _vm._l(_vm.items, function(item, index) {
    return _c("li", { key: index, staticClass: "breadcrumb__element", attrs: { "itemprop": "itemListElement", "itemscope": "", "itemtype": "http://schema.org/ListItem" } }, [item.to ? _c("LinkButton", { staticClass: "breadcrumb__link", class: { "breadcrumb__link--is-active": _vm.isActive(index) }, attrs: { "data-tealium-rel": _vm.trackingKey(item.label), "to": item.to, "tag": "nuxt-link", "exact": "", "itemprop": "item", "no-styling": "" } }, [_c("span", { attrs: { "itemprop": "name" } }, [_vm._v(_vm._s(item.label))])]) : _c("span", { staticClass: "breadcrumb__link", class: { "breadcrumb__link--is-active": _vm.isActive(index) } }, [_c("span", { attrs: { "itemprop": "name" } }, [_vm._v(_vm._s(item.label))])]), _c("span", { attrs: { "content": _vm.homeName ? index + 2 : index + 1, "itemprop": "position" } })], 1);
  })], 2), _vm.withBrodos ? _c("span", { staticClass: "breadcrumb__element breadcrumb__brodos-claim" }, [_vm._v(" In Kooperation mit "), _c("BrodosLogo", { staticClass: "breadcrumb__brodos-claim-logo", attrs: { "height": 12, "width": 51 } })], 1) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ee66a159",
  null,
  null
);
const breadcrumb = __component__.exports;
export {
  breadcrumb as default
};
